module.exports = __webpack_public_path__ + "static/img/MU@2x.213512f2.jpg";